import './BuildTag.css';

declare const __APP_VERSION__: string;

/**
 * Номер сборки в углу экрана.
 *
 * Нужен, чтобы по скриншоту от коллеги было понятно, какая версия у него
 * открыта — без этого непонятно, воспроизводится ли баг на актуальной
 * сборке или человек просто не обновил вкладку. Поэтому подпись видна,
 * но намеренно приглушена: замечаешь, когда ищешь, и не мешает, когда
 * не ищешь.
 */
export function BuildTag() {
  return (
    <span className="build-tag" aria-hidden>
      {__APP_VERSION__}
    </span>
  );
}
